import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import CarItem from 'components/CarItem';
// import Button from 'components/Button';
import { URLS } from 'config';

import containerActions from './actions';

import './styles.scss';


class ProfileCarsPage extends React.Component {
  componentWillMount() {
	  if (!Object.keys(this.props.user).length) {
	    this.props.history.replace(URLS.LOGIN);
	  } else {
      this.props.getSelectedCars();
    }
  }

  render () {
    return (
      <div className="page-profile-cars -not-full">
        <p className="cars-title">
          Your cars
        </p>

        <div className="cars-list">
          <CarItem
            name={this.props.car && this.props.car.name}
            perMounth={this.props.car.price || 0}

            image={this.props.car && this.props.car.media
              && this.props.car.media.photo_links
              && this.props.car.media.photo_links.length
              ? this.props.car.media.photo_links[0] : null
            }
            delivery={this.props.car && this.props.car.date ? this.props.car.date : new Date()}
          />
        </div>

        {/* <Button
          disabled={false}
        >
      Add a car
        </Button> */}
        {/* <Button
      disabled={false}
    >
      Finish uploading documents
    </Button> */}
      </div>
    );
  }
}

ProfileCarsPage.propTypes = {
  // eslint-disable-next-line
  car: PropTypes.object,
  getSelectedCars: PropTypes.func.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired
};

const mapToStateProps = state => ({
  user: state.user.user,
  car: state.profileCars.cars
});

export default connect(mapToStateProps, containerActions)(ProfileCarsPage);



// WEBPACK FOOTER //
// ./src/pages/ProfileCars/index.js